import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';

@Injectable()
export class DateFirstDayWeekByDefaultUiFeature implements IFlagFeature {
  name = Features.DATE_FIRST_DAY_WEEK_BY_DEFAULT_UI;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
